import { Route, Routes, useLocation } from 'react-router-dom'
import { AnimatePresence } from "framer-motion";

import { useEffect, Suspense, lazy } from 'react';
import { Projects, Amenities, AmenitiesDetails } from './data/ProjectDetails';

const Home = lazy(() => import("./views/Home"));
const About = lazy(() => import('./views/About'));
const ProjectsPage = lazy(() => import('./views/ProjectsPage'));
const Z2 = lazy(() => import('./views/Z2'));
const Zluxuria = lazy(() => import('./views/Zluxuria'));
const Zstone = lazy(() => import('./views/Zstone'));
const Zsbr = lazy(() => import('./views/zsbrComingSoon'));
const Tragad = lazy(() => import('./views/tragadComingSoon'));
const Thaltej = lazy(() => import('./views/thaltejComingSoon'));
const CorporateSpaces = lazy(() => import('./views/CorporateSpaces'));
const PrivacyPolicy = lazy(() => import('./views/PrivacyPolicy'));

function App() {


  const location = useLocation();
  // const navigate = useNavigate();

  useEffect(() => {
    // Background Image Preloader (Cache all images from ProjectDetails)
    const imagesToPreload = [];
    Projects.forEach(p => {
      if (p.logo) imagesToPreload.push(p.logo);
      if (p.image) imagesToPreload.push(p.image);
      if (p.aboutDetails) {
        p.aboutDetails.forEach(d => { if (d.icon) imagesToPreload.push(d.icon); });
      }
    });

    Object.values(Amenities).forEach(arr => {
      arr.forEach(a => { if (a.SVG) imagesToPreload.push(a.SVG); });
    });

    Object.values(AmenitiesDetails).forEach(arr => {
      arr.forEach(a => { if (a.image) imagesToPreload.push(a.image); });
    });

    // Fire off requests to download and cache them
    imagesToPreload.forEach(src => {
      const img = new Image();
      img.src = src;
    });

  }, [location.pathname]);

  useEffect(() => {
    // Track page views in Google Analytics on route change
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return (


    <Suspense fallback={<div className="h-screen w-full flex items-center justify-center text-primary text-2xl font-primary">Loading...</div>}>
      <AnimatePresence mode="wait" onExitComplete={() => window.scrollTo(0, 0)}>
        <Routes location={location} key={location.key}>

          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/z2" element={<Z2 />} />

          <Route path="/zluxuria" element={<Zluxuria />} />
          <Route path="/zstone" element={<Zstone />} />
          <Route path="/zsbrComingSoon" element={<Zsbr />} />
          <Route path="/tragadComingSoon" element={<Tragad />} />
          <Route path="/thaltejComingSoon" element={<Thaltej />} />
          <Route path="/corporate-spaces" element={<CorporateSpaces />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />


        </Routes>
      </AnimatePresence>
    </Suspense>

  );
}


export default App;
